<aum-cli-spinner [isLoading]="showSpinner"></aum-cli-spinner>
<div class="mt-40 mt-lg-30" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="12px">
  <p class="medium font-lg-12">
    {{
      isLoginScreen
        ? ('login.socialTitle' | translate)
        : ('registration.socialTitle' | translate)
    }}:
  </p>
  <div fxLayout fxLayoutAlign="center center" fxLayoutGap="10px">
    <div class="icon" (click)="signInWithGoogle()">
      <img src="./assets/images/icons/google.svg" alt="google" />
    </div>
    <!-- <div class="icon" (click)="signInWithFB()">
      <img src="./assets/images/icons/facebook.svg" alt="fb" />
    </div> -->
  </div>
</div>
